export default "__VITE_ASSET__BwOfS1hh__"